
class BlogFilter extends HTMLElement {
  constructor() {
    super();

	this.mainBlog = document.querySelector('.main-blog');
	this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('click', this.onFilterClick.bind(this)));
  }

  onFilterClick(event) {
    const inputElement = event.currentTarget;
    const url = inputElement.previousElementSibling.href;

    this.mainBlog.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    
    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = new DOMParser().parseFromString(text, "text/html");
      const newMainBlog = html.querySelector('.main-blog');
      const newFilter = html.querySelector('blog-filter');
      
      this.mainBlog.innerHTML = newMainBlog.innerHTML;
      this.innerHTML = newFilter.innerHTML;
      this.bindEvents();
    })
    .catch(e => {
    	console.error(e);
    })
    .finally(() => {
      this.mainBlog.classList.remove('loading');
      //this.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  }
}

customElements.define('blog-filter', BlogFilter);